<template>
  <v-container class="pa-0">
    <template v-if="viewDataIsLoaded">
      <app-admin-data-table :tableData="viewData" :downloadable="true"></app-admin-data-table>
    </template>
    <!--snack-bar-->
    <app-snack-bar></app-snack-bar>
  </v-container>
</template>

<script>
import axios from 'axios'
import SnackBar from '../components/SnackBar'
import AdminDataTable from '../components/AdminDataTable'
import { generalMixin } from '../mixins/general'
import { urlMixin } from '../mixins/url'
import { mapGetters } from 'vuex'
import { snackBarBus } from '../main'

export default {
  components: {
    'app-snack-bar': SnackBar,
    'app-admin-data-table': AdminDataTable
  },
  mixins: [generalMixin, urlMixin],
  data() {
    return {
      viewDataIsLoaded: false,
      viewData: {},
      restPath: 'assignment'
    }
  },
  computed: {
    ...mapGetters(['loggedInData', 'access_token', 'agentName', 'getHomeRoute']),
  },
  methods: {
    onTabChange(index) {
      this.tabIndex = index
    },
    doOnViewData(returnData) {
      this.viewData = returnData
      this.viewDataIsLoaded = true
    },
    loadViewData() {
      let config = {
        headers: {
          'Authorization': this.access_token
        }
      }
      let url = this.url_composeApiUrl('/admin/' + this.restPath)
      console.log('get', url)
      axios.get(url, config)
        .then(response => {
          console.log('response', response)
          if (response.data.success) {
            //success
            this.doOnViewData(response.data.returnData)
          } else if (this.onNonSuccessApiCall(response.data.returnData)) {
            snackBarBus.$emit('message', this.generalParseErrorArray(response.data.returnData.error_ar))
          }
        })
        .catch(error => {
          snackBarBus.$emit('message', error.toString())
        })
    }  
  },
  created() {
    //get viewData
    this.loadViewData()
  },
  destroyed() {
  }
}
</script>

<style>

</style>